export default __webpack_public_path__ + "static/Image-2-5094f4713a301b759bf696f1aaae2f6c.png";